// Shared value utilities
export class ValueUtils {
    /** Returns undefined for null/undefined or empty/whitespace strings; otherwise returns the original value */
    static emptyToUndefined<T>(value: T | undefined | null): T | undefined {
        if (value === undefined || value === null) return undefined;
        if (typeof value === 'string' && value.trim().length === 0) return undefined;
        return value as T;
    }

    static toErrorMessage(error: unknown, fallback: string): string {
        return error instanceof Error && error.message ? error.message : fallback;
    }
}
